import axiosInstance from "@/api/axios";

import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label, Text} from 'recharts';
import Button from "@/common/Components/Button/Button";
import {useEffect, useState, useContext, useRef} from "react";

import "./BinLineChart.css";
import {RiDeleteBin7Line} from "react-icons/ri"
import * as XLSX from 'xlsx';
import {Tooltip as ReactTooltip} from 'react-tooltip'
import {FaFileExport} from 'react-icons/fa'
import {BiMenu} from "react-icons/bi";
import CustomCalendar from "@/common/Components/Calendar/Calendar";
import {AiTwotoneCalendar, AiOutlineClose} from "react-icons/ai"
import {AiOutlineArrowDown} from 'react-icons/ai'
import {AiOutlineArrowUp} from 'react-icons/ai'
import {CSSTransition} from 'react-transition-group';
import {AiFillInfoCircle} from 'react-icons/ai'
import html2canvas from 'html2canvas';
import PropTypes from 'prop-types';
import useId from "../useId";
import {useTranslation} from "react-i18next";


const BinLineChart = ({
                          id_,
                          selectedValue_,
                          bin_,
                          selectedButton_,
                          datevalue_,
                          currentWasteItem_,
                          darkM_,
                          dayvalue_,
                          setSelectedValue_,
                          language
                      }) => {


    const [chartData, setChartData] = useState({});
    const [lineChartDate, setlineChartDate] = useState(dayvalue_);
    const [selectedBin, setSelectedBin] = useState("0");
    const [totalWaste, setTotalWaste] = useState();
    const [selectedButton, setSelectedButton] = useState(dayvalue_);
    const [tier, setTier] = useState('');
    const [selectedFormat, setSelectedFormat] = useState('xlsx');
    const [calendarclick, setCalendarClick] = useState(false);
    const [totalwasteproduced, setTotalWasteProduced] = useState();
    const [colorwaste, setColorWaste] = useState();
    const [percentagechange, setPercentageChange] = useState();
    const [TotalWasteWeight, setTotalWasteWeight] = useState('')
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [binUniqueId, setBinUniqueId] = useState(id_);
    const currentBin = bin_;
    const currentBinId = currentBin?.id;
    const [id, setId] = useState(0);
    const {t, i18n} = useTranslation();
    const binlinecharttitle = t('binlinechartlabel');
    const [data, setData] = useState();


    // Labels for different time ranges
    const dayLabels = Array.from({length: 24}, (_, i) => `${i}:00`);
    const weekLabels = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    const monthLabels = Array.from({length: 31}, (_, i) => (i + 1).toString());
    const threeMonthLabels = ["Month 1", "Month 2", "Month 3"];
    const sixMonthLabels = ["Month 1", "Month 2", "Month 3", "Month 4", "Month 5", "Month 6"];
    const yearLabels = Array.from({length: 12}, (_, i) => new Date(0, i).toLocaleString('default', {month: 'long'}));

    const [lineChartLabels, setLineChartLabels] = useState(dayLabels);

    useEffect(() => {
        switch (selectedButton_) {
            case 'day':
                setLineChartLabels(dayLabels);
                break;
            case 'week':
                setLineChartLabels(weekLabels);
                break;
            case 'month':
                setLineChartLabels(monthLabels);
                break;
            case '3month':
                setLineChartLabels(threeMonthLabels);
                break;
            case '6month':
                setLineChartLabels(sixMonthLabels);
                break;
            case 'year':
                setLineChartLabels(yearLabels);
                break;
            default:
                setLineChartLabels(dayLabels);
                break;
        }
    }, [selectedButton_]);


    const [datevalue, setDateValue] = useState(datevalue_);

    useEffect(() => {
        resetDates();
    }, [dayvalue_, selectedButton, datevalue]);


    const resetDates = () => {
        setDateValue([
            {
                startDate: null,
                endDate: null,
                key: 'selection'
            }
        ]);
    };


    const handleCloseCalendar = () => {
        setCalendarClick(false);
    }
    const handleDateValueChange = (newDateValue) => {
        setDateValue(newDateValue);
        setCalendarClick(false)
    }

    const handleCalendarClick = () => {
        setCalendarClick(!calendarclick);
    }

    const handleModalClick = () => {
        setModalIsOpen(false)
    }

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const chartRef = useRef(null);


    const filterlang = () => {

        if (selectedButton_ === 'year' && '') {
            return "jaar";
        }

        if (selectedButton_ === '6months') {
            return "6 maanden";
        }

        if (selectedButton_ === '3months') {
            return "3 maanden";
        }

        if (selectedButton_ === 'month') {
            return "maanden";
        }

        if (selectedButton_ === 'week') {
            return "week";
        }

        if (selectedButton_ === 'day') {
            return "dag";
        }

        if (selectedButton_ === 'custom') {
            return "aangepast";
        }
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };
    const week = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
    ];
    const [month, setMonth] = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"];
    const [month3, setMonth3] = useState(["Month 1", "Month 2", "Month 3"]);
    const day = [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
    ];
    const [lineChartLabel, setlineChartLabel] = useState();
    const [theme, setTheme] = useState();


    const translations = {
        day: 'dag',
        week: 'week',
        month: 'maand',
        '3months': '3 maanden',
        '6months': '6 maanden',
        year: 'jaar'
    };

    const translatedSelectedButton = language === "Dutch" ? translations[selectedButton] : selectedButton;
    const message = `Totaal Afval in Vergelijking Met Vorige ${translatedSelectedButton}`;

    const translateToDutch = (text) => {
        const translations = {
            "Monday": "Maandag",
            "Tuesday": "Dinsdag",
            "Wednesday": "Woensdag",
            "Thursday": "Donderdag",
            "Friday": "Vrijdag",
            "Saturday": "Zaterdag",
            "Sunday": "Zondag",
            "January": "Januari",
            "February": "Februari",
            "March": "Maart",
            "April": "April",
            "May": "Mei",
            "June": "Juni",
            "July": "Juli",
            "August": "Augustus",
            "September": "September",
            "October": "Oktober",
            "November": "November",
            "December": "December",
            "Organic": "Biologisch",
            "PMD": "PMD",
            "Paper": "papier",
            "Residual": "Resterend",
        };
        return translations[text] || text;
    }


    useEffect(() => {
        axiosInstance.get("/get_bins")
            .then((response) => {
                response.data.map(bin => {
                    if (bin.unique_identifier === id_ || bin.unique_identifier === binUniqueId) {
                        setSelectedBin(bin);
                        console.log("Result from get_bins:");
                        console.table(bin);
                        console.log("Result from get_bins bin_id:");
                        console.table(bin.id);
                        setId(bin.id)

                        // Update binUniqueId if necessary
                        setBinUniqueId(bin.unique_identifier);
                    }
                });
            })
            .catch((error) => {
                console.error("Error fetching bins:", error);
            });
    }, [id_, binUniqueId]); // Add binUniqueId here


    useEffect(() => {
        axiosInstance
            .get("/usertier")
            .then((response) => {
                console.log(response.data.tier)
                setTier(response.data.tier)
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    useEffect(() => {
        if (bin_ === undefined) {
            axiosInstance
                .get(`/totalwastebindash/0/${selectedButton_}`)
                .then((response) => {
                    setPercentageChange(parseFloat(response.data?.percentage_change).toFixed(2))
                    setColorWaste(response.data?.color)
                    setTotalWasteProduced(response.data?.total_waste_current)
                    setTotalWasteWeight(response.data?.waste_weight)
                });
        } else {
            setSelectedBin(bin_);
            axiosInstance.get(`/totalwastebindash/${id}/${selectedButton_}/`, {
                params: {
                    wasteitem: currentWasteItem_,

                }
            }).then((response) => {
                console.log("/BinLineChart", response.data);  // Correctly logs the response data

                setPercentageChange(parseFloat(response.data?.percentage_change).toFixed(2));
                setColorWaste(response.data?.color);
                setTotalWasteProduced(response.data?.total_waste_current);
                setTotalWasteWeight(response.data?.waste_weight);
            })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                });
        }
    }, [selectedButton_, dayvalue_, currentBin, id]);


    useEffect(() => {
        axiosInstance
            .get(`/get_waste_data/${id}/${selectedButton_}/`)
            .then((response) => {
                const {label, results, total_waste_current, percentage_change} = response.data;
                setChartData({
                    labels: label.map((label) => (i18n.resolvedLanguage === 'nl' ? translateToDutch(label) : label)),
                    datasets: results.map((dataset, index) => {
                        let borderColor, backgroundColor;
                        if (index === 0) {
                            borderColor = "#004800";
                            backgroundColor = "#004800";
                        } else if (index === 1) {
                            borderColor = "#EAD200";
                            backgroundColor = "#EAD200";
                        } else if (index === 2) {
                            borderColor = "#4D89FF";
                            backgroundColor = "#4D89FF";
                        } else if (index === 3) {
                            borderColor = "#B07F00";
                            backgroundColor = "#B07F00";
                        }
                        return {
                            ...dataset,
                            label: i18n.resolvedLanguage === 'nl' ? translateToDutch(dataset.label) : dataset.label,
                            borderColor,
                            tension: 1.0, //makes the line smoother
                            pointRadius: 3,
                            fill: true,
                            backgroundColor: (context) => {
                                const chart = context.chart;
                                const {ctx, chartArea} = chart;
                                if (!chartArea) return null;

                                const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                                gradient.addColorStop(0, 'rgba(0, 72, 0, 0.1)');
                                gradient.addColorStop(1, 'rgba(0, 72, 0, 0.5)');
                                return gradient;
                            },
                        };
                    }),
                });
                setTotalWasteProduced(total_waste_current);
                setPercentageChange(percentage_change);
            })
            .catch((error) => {
                console.error("Error fetching chart data:", error);
            });
    }, [selectedButton_, selectedBin, id]);


    const handleClick = (e) => {
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        onHover: (event, chartElement) => {
            event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
        },
        plugins: {
            title: {
                display: true,
                text: binlinecharttitle,
                font: {
                    family: "Poppins",
                    size: 18,
                    weight: "bolder",
                },
                padding: {
                    top: 10,
                    bottom: 30,
                },
            },
            datalabels: {
                display: false,
            },
            legend: {
                position: "top",
                align: "end",
                labels: {
                    usePointStyle: true,
                },
            },
        },
        scales: {
            y: {
                type: "linear",
                display: true,
                position: "right",
                beginAtZero: true,
                grid: {
                    display: true,
                    // drawOnChartArea: false,
                },
                ticks: {
                    color: theme,
                },
            },
            x: {
                display: true,
                beginAtZero: true,
                grid: {
                    display: false,
                    // drawOnChartArea: false,
                },
                ticks: {
                    color: theme,
                },
            },
        },
        spanGaps: false,
    };


    useEffect(() => {

        let startDate = new Date(datevalue_[0].startDate);
        let endDate = new Date(datevalue_[0].endDate);



        if (datevalue === undefined) {
            startDate = new Date();
            endDate = new Date();

        } else {
            //startDate =  new Date(datevalue[0].startDate);
            //endDate = new Date(datevalue[0].endDate);
        }

        const defaultDateString = 'Thu Jan 01 1970 03:00:00 GMT+0300 (East Africa Time)';


        const params = {
            'startDate': startDate.toString(),
            'endDate': endDate.toString(),
            'withcalendar': selectedButton_ === 'custom' ? true : false,
        };

        setSelectedBin(bin_);
        console.log("get_waste_weight data", currentBin?.id);

        axiosInstance
            .get(`/get_waste_weight/${id}/${selectedButton_}`, {
                withCredentials: true,
                params: params,
            })
            .then((response) => {
                console.log("rechart line data :", response?.data)
                if (selectedButton_ === "month" || selectedButton_ === "3months" || selectedButton_ === "6months" || selectedButton_ === "year") {
                    setData(response?.data);
                } else {
                    setData(response?.data);
                }
            })
    }, [selectedButton_, currentBin, dayvalue_, id, datevalue_]);

    const exportToExcel = (chartData) => {
        // Create a new workbook
        const wb = XLSX.utils.book_new();
        let streamvalue = language === "Dutch" ? "Afval Vergelijking" : "Waste Comparison"
        // Prepare the data
        const data = chartData.labels.map((label, index) => {
            let Date = language === "Dutch" ? "Datum" : "Date";
            return chartData.datasets.reduce((obj, dataset) => {
                obj[dataset.label] = dataset.data[index];
                return obj;
            }, {[Date]: label});
        });

        // Convert the data to worksheet
        const ws = XLSX.utils.json_to_sheet(data);

        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        const date = new Date();
        const formattedDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;

        // Write the workbook to a file
        XLSX.writeFile(wb, `${streamvalue}_${formattedDate}.xlsx`);
    };

    const exportToCSV = (chartData) => {
        let streamvalue = language === "Dutch" ? "Afval Vergelijking" : "Waste Comparison";

        // Prepare CSV data
        const csvData = [];

        // Create the header row
        const headerRow = ["Date", ...chartData.datasets.map(dataset => dataset.label)]; // Modify headers as needed
        csvData.push(headerRow);

        // Create rows with data
        chartData.labels.forEach((label, index) => {
            const rowData = [label, ...chartData.datasets.map(dataset => dataset.data[index])]; // Modify data fields as needed
            csvData.push(rowData);
        });

        // Convert data to CSV string
        const csvContent = csvData.map((row) => row.join(",")).join("\n");

        // Create a Blob and trigger a download
        const blob = new Blob([csvContent], {type: "text/csv"});
        if (window.navigator.msSaveBlob) {
            const date = new Date();
            const formattedDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
            // For IE
            window.navigator.msSaveBlob(blob, `${streamvalue}_${formattedDate}.csv`);
        } else {
            // For modern browsers
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `${streamvalue}.csv`;
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };


    const handleExporttoExcel = (option) => {
        if (option === 'xlsx') {
            exportToExcel(chartData);
        } else if (option === 'csv') {
            exportToCSV(chartData);
        } else if (option === 'png') {
            exportChartAsPNG();
        }
    }


    const exportChartAsPNG = () => {

        const chartSection = document.getElementById('BinChartContainer');

        html2canvas(chartSection).then(canvas => {

            const image = canvas.toDataURL('image/png');

            // Generate filename
            let streamvalue = language === "Dutch" ? "Afval Vergelijking" : "Waste Comparison"
            const date = new Date();
            const formattedDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
            const filename = `${streamvalue}_${date}.png`;

            // Pass filename to save function
            saveDataURLToFile(image, filename);

        });

    };
    const saveDataURLToFile = (dataURL, filename) => {

        // convert data URL to blob
        const blob = dataURLToBlob(dataURL);

        // create object URL from blob
        const url = URL.createObjectURL(blob);

        // create anchor tag
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;

        // click to download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    };

    const dataURLToBlob = (dataURL) => {
        // Convert base64 to raw binary data held in a string
        const byteString = atob(dataURL.split(',')[1]);

        const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];

        const arrayBuffer = new ArrayBuffer(byteString.length);

        const ia = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        const blob = new Blob([arrayBuffer], {type: mimeString});
        return blob;

    };


    const renderLabel = () => {
        return (
        <text
            x="50%"
            y="30"
            textAnchor="middle"
            fill="#666"
            fontSize="18px"
            fontWeight="bold"
            fontFamily="Poppins"
        >
            {t('binlinechartlabel')}
        </text>
    );
    };

    return (
        <div>
            {tier === 'Business' && (
                <div className="">
                    <div className="flex text-center">
                        <AiFillInfoCircle
                            className="h-5 w-5 text-plaex-bar hover:text-green-500 cursor-pointer mr-2"
                            onClick={() => setModalIsOpen(!modalIsOpen)}
                        />
                        <div className="relative">
                            <div>
                                <button className="w-6 h-6 text-black underline hover:text-green-500 cursor-pointer"
                                        onClick={toggleDropdown}>
                                    {t('exportlabel')}
                                </button>
                                {isDropdownOpen && (
                                    <CSSTransition
                                        in={isDropdownOpen}
                                        timeout={200}
                                        classNames="slide"
                                        unmountOnExit
                                    >
                                        <div
                                            className="absolute flex flex-row left-16 -top-2 bg-white border border-gray-300 p-1 rounded shadow">
                                            <button onClick={() => handleExporttoExcel('xlsx')}
                                                    className="text-black underline hover:text-green-500 p-2 text-sm">
                                                XLSX
                                            </button>
                                            <button onClick={() => handleExporttoExcel('csv')}
                                                    className="text-black underline hover:text-green-500 p-2 text-sm">
                                                CSV
                                            </button>
                                            <button onClick={() => handleExporttoExcel('png')}
                                                    className="text-black underline hover:text-green-500 p-2 text-sm">
                                                PNG
                                            </button>
                                        </div>
                                    </CSSTransition>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className=" flex flex-col items-end justify-end">

                    </div>


                </div>
            )}


            {/* Waste Level Chart  */}


            <ReactTooltip id="co2savings"/>
            <div className="waste-level-chart pt-20 pl-5 m-0">
                <div className="waste-level-chart-content" id="BinChartContainer">
                    {data && (
                        <ResponsiveContainer width="100%" height="100%">

                            <LineChart
                                width={500}
                                height={840}
                                data={data}
                                margin={{ top: 30, right: 0, left: 0, bottom: 0 }}

                            >
                                {renderLabel()}
                                <CartesianGrid vertical={false}/>
                                <XAxis dataKey="date"/>
                                <YAxis/>
                                <Tooltip/>
                                <Legend verticalAlign="top" align="right" height={36}/>
                                <Line type="monotone" dataKey="paper" stroke="#4D89FF" strokeWidth={2} dot={false}/>
                                <Line type="monotone" dataKey="organic" stroke="#004800" strokeWidth={2} dot={false}/>
                                <Line type="monotone" dataKey="residual" stroke="#B07F00" strokeWidth={2} dot={false}/>
                                <Line type="monotone" dataKey="pmd" stroke="#EAD200" strokeWidth={2} dot={false}/>
                            </LineChart>
                        </ResponsiveContainer>
                    )}
                </div>
            </div>

            {modalIsOpen && (
                <>
                    <div className="fixed inset-0 bg-black opacity-50 z-40"></div>
                    <div className="fixed inset-0 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg shadow-lg p-6 pb-10 z-50 w-full sm:max-w-md">
                            <button onClick={handleModalClick}
                                    className="text-2xl font-black ml-6 mt-6 hover:text-plaex-bar transition-transform duration-300 ease-in-out transform hover:scale-[0.8] ">
                                <AiOutlineClose/></button>
                            <div>
                                This interactive chart provides a comprehensive view of the different wastes generated
                                over time. You can filter the chart by date range to analyze trends and patterns in your
                                Waste Comparison Page. Hover over any data point to see the exact figures for a
                                particular time. Use the filters above the chart to focus on date ranges for the waste
                                streams.
                                Switch between the different bins using the dropdown on the side bar. This chart allows
                                you to compare and contrast trends across the different waste categories without the
                                need to switch to differnt waste streams. You can export the filtered chart data as a
                                CSV or XSLX file for further analysis and use in other tools.
                            </div>

                        </div>
                    </div>
                </>
            )}

            {calendarclick && (
                <div
                    className={calendarclick ? "z-50 flex flex-col rounded-lg shadow-lg absolute bg-white top-32 w-full " : "z-50 flex flex-col rounded-lg shadow-lg absolute top-32 w-full bg-white "}>
                    <div className="flex items-start justify-start">
                        <button onClick={handleCloseCalendar}
                                className="text-2xl font-black ml-6 mt-6 hover:text-plaex-bar transition-transform duration-300 ease-in-out transform hover:scale-[0.8] ">
                            <AiOutlineClose/></button>
                    </div>
                    <CustomCalendar datevalue={datevalue} onDateValueChange={handleDateValueChange}/>
                </div>

            )}
        </div>
    );
};


/**
 *
 * BinLineChart.propTypes = {
 *     bin_: PropTypes.object.isRequired,
 * }
 */



export default BinLineChart;